export default __webpack_public_path__ + "static/media/proposal.a4e39494.svg";